import type { AbstractCtaProps, CtaRefType, ButtonType } from 'util/cta/cta.data';

export type PlayButtonRef = CtaRefType;

export const defaultButtonType: ButtonType = 'button';

export const buttonSizes = [
  // 'medium',
] as const;

export type ButtonSize = (typeof buttonSizes)[number];

export type PlayButtonProps = {
  size?: ButtonSize;
  isMagnetic?: boolean;
  isPlaying?: boolean;

  // todo: maybe refactor transition-component and add as default option?
  disableTriggerInOnScroll?: boolean;
  triggerInOnce?: boolean;
} & AbstractCtaProps;
